module.exports = __webpack_public_path__ + "static/media/personal-challenge-preview.2c8b71b0.png";